(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/redux/slices/containers/selectors.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/redux/slices/containers/selectors.js');

'use strict';

const {
  createSelector
} = RTK;
const {
  productMapping,
  draws: {
    drawsApi
  }
} = svs.numbergames;
const {
  containerStates
} = svs.numbergames.fractiongames.constants;
const {
  productsSortOrder
} = svs.numbergames.fractiongames.data;
const getSortOrderByRegCloseTime = () => Object.entries(drawsApi.regCloseTime()).map(_ref => {
  let [key, value] = _ref;
  return {
    productNumeric: productMapping.getProductNumeric(key),
    regCloseTime: new Date(value)
  };
}).sort((a, b) => a.regCloseTime - b.regCloseTime).map(item => item.productNumeric);
const selectContainers = createSelector(state => state.containers, containers => Object.values(containers), {
  memoizeOptions: {
    resultEqualityCheck: (arr1, arr2) => (arr1 === null || arr1 === void 0 ? void 0 : arr1.length) === (arr2 === null || arr2 === void 0 ? void 0 : arr2.length)
  }
});
const createSortedContainersSelector = productFilter => createSelector(selectContainers, containers => {
  containers = containers.filter(container => container.game);
  if (productFilter) {
    containers = containers.filter(container => productMapping.isSameProduct(container.productNumeric, productFilter));
  }
  const sortOrder = productsSortOrder !== null && productsSortOrder !== void 0 && productsSortOrder.length ? productsSortOrder : getSortOrderByRegCloseTime();
  return containers.sort((a, b) => parseInt(a.sharePrice, 10) - parseInt(b.sharePrice, 10)).sort((a, b) => sortOrder.indexOf(a.productNumeric) - sortOrder.indexOf(b.productNumeric)).map(container => container.containerId);
}, {
  memoizeOptions: {
    resultEqualityCheck: (arr1, arr2) => {
      var _arr1$join, _arr2$join;
      return (arr1 === null || arr1 === void 0 || (_arr1$join = arr1.join) === null || _arr1$join === void 0 ? void 0 : _arr1$join.call(arr1)) === (arr2 === null || arr2 === void 0 || (_arr2$join = arr2.join) === null || _arr2$join === void 0 ? void 0 : _arr2$join.call(arr2));
    }
  }
});
const createContainerSelector = containerId => createSelector(state => state.containers, containers => containers[containerId]);
const containerSelectors = {
  selectContainerId: container => container.containerId,
  selectActivatedDrawId: container => container.activatedDrawId,
  selectProductNumeric: container => container.productNumeric,
  selectDrawNumber: container => drawsApi.drawNumber(container.productNumeric),
  selectSharePrice: container => container.sharePrice,
  selectTotalPrice: container => container.totalPrice,
  selectSharesLeft: container => container.activatedDrawId ? container.totalShares - container.soldShares : 0,
  selectTotalShares: container => container.totalShares,
  selectBuyinCloseTime: container => container.buyinCloseTime,
  selectGame: container => container.game,
  selectIsOpen: container => container.containerState === containerStates.CONTAINER_OPEN,
  selectIsSoldOut: container => container.containerState === containerStates.GAME_SOLD_OUT,
  selectIsClosed: container => container.containerState === containerStates.CONTAINER_CLOSED,
  selectContainerState: container => container.containerState
};
const createContainerSelectors = containerId => {
  const selectContainer = createContainerSelector(containerId);
  return Object.entries(containerSelectors).reduce((acc, _ref2) => {
    let [key, selector] = _ref2;
    return Object.assign(acc, {
      [key]: createSelector(selectContainer, selector)
    });
  }, {});
};
Object.assign(svs.numbergames.fractiongames.redux.slices.containers, {
  selectors: {
    createSortedContainersSelector,
    createContainerSelectors
  }
});

 })(window);